import { apiClient } from "../../client";
import { PaginatedResponse } from "../role.repository";


export interface TradeType {

    id: number;
    tenant_id: number;
    en_name: string;
    ar_name?: string | null;
    status: number;
    created_by?: number;
    updated_by?: number;
    created_at: number;
    updated_at: number;
}

export interface CreateTradeType {
    tenant_id: number;
    en_name: string;
    ar_name?: string;
    status?: number;
}

export interface UpdateTradeType {
    tenanat_id?: number;
    en_name?: string;
    ar_name?: string;
    status?: number;
}

class TradeTypeRepository {

    async getAll(page: number = 1, limit: number = 10, filters?: any): Promise<PaginatedResponse<TradeType>> {

        const params = new URLSearchParams({
            page: page.toString(),
            limit: limit.toString()
        });

        if (filters.search) {
            params.append('search', filters.search);
        }

        if (filters.status) {
            params.append('status', filters.status);
        }

        if (filters.trade_type_id) {
            params.append('trade_type_id', filters.trade_type_id)
        }

        return apiClient.get<PaginatedResponse<TradeType>>(`/trade-types?${params.toString()}`);

    }

    async getById(id: number): Promise<TradeType> {

        return apiClient.get<TradeType>(`/trade-types/${id}`);

    }

    async create(data: CreateTradeType): Promise<TradeType> {
        return apiClient.post<TradeType>(`/trade-types`, data);

    }

    async update(id: number, data: UpdateTradeType): Promise<TradeType> {
        return apiClient.put<TradeType>(`/trade-types/${id}`, data)
    }

    async delete(id: number): Promise<{ message: string }> {
        return apiClient.delete<{ message: string }>(`/trade-types/${id}`);
    }

    async exportToExcel(filters?: any): Promise<Blob> {

        const params = new URLSearchParams();

        if (filters?.search) {
            params.append('search', filters.search);
        }

        if (filters?.status) {
            params.append('status', filters.status);
        }

        if (filters?.trade_type_id) {
            params.append('trade_type_id', filters.trade_type_id.toString())
        }

        const baseUrl = `/trade-types/export/excel`;
        const queryString = params.toString();
        const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;

        return apiClient.getBlob(url, true, { showSuccessToast: true, successMessage: 'Exported Successfully' })
    }


}

export const tradeTypeRepository = new TradeTypeRepository();